import {createContext} from 'react'
import type {DragAndDropDirection} from '../utils/types'

export const DragAndDropContext = createContext<{
  dragIndex: number | null
  moveToPosition: (currentPosition: number, newPosition: number, isBefore?: boolean) => void
  overId: string | number | null
  items: Array<{id: string | number; title: string}>
  direction: DragAndDropDirection
} | null>(null)
